module.exports = __webpack_public_path__ + "static/media/11_l_dom_0_41.39.165b4395.png";